import React from 'react';
import { Grid, Checkbox, Typography } from '@mui/material';
import {
    SimpleDialog,
    ButtonLoading,
    Icons
} from 'components';

import { makeStyles } from '@mui/styles';
import { useEffect } from 'react';
import { useState } from 'react';
import clsx from 'clsx';
import { CheckBoxIcon, CheckBoxIconFill } from 'components/CheckBox/CheckBoxIcon';
const useStyles = makeStyles((theme) => {
    return {
        chkItem: {
            display: 'flex',
            justifyContent: 'space-between',
            cursor: 'pointer',
            backgroundColor: '#f4f4f4',
            borderRadius: '8px',
            fontSize: '12px',

            border: '2px solid #f4f4f4',
            alignItems: 'center',
            padding: '2px 12px',
            margin: '4px 0',
            transitionDuration: '200ms',
            '&:hover': {
                //marginRight: '4px',
                marginLeft: '4px',
                transitionDuration: '200ms',

            }
        },
        activeItem: {
            border: '2px solid #449cc9',
            //border: '2px solid #2B3990',
        },
        colorActive: {
            color: '#2B3990',
            fontWeight: 'bold',
        },
        colorActivePlace: {
            opacity: '1'
        },
        colorPlace: {
            opacity: '0.3',
            fontWeight: 'bold'
        },
        customClassdialogContent: {
            minWidth: '440px',
            [theme.breakpoints.down('sm')]: {
                minWidth: 'auto',
            },
        },
        font13: {
            fontSize: '13px',
        }

    };
});
const AddAgentDg = (props) => {
    const { isOpenAgentDg, setIsOpenAgentDg, data = [], agentList, setAgentList } = props;
    const [copyAgentList, setCopyAgentList] = useState([]);
    const classes = useStyles();

    useEffect(() => {
        isOpenAgentDg && setCopyAgentList([...JSON.parse(JSON.stringify(agentList))])
    }, [isOpenAgentDg])

    /**
     * سرویس به اینجا وصل میشود
     */
    const getAgentList = () => {

    }

    const onToggleChecked = (item) => {



        item['isSelected'] = item['isSelected'] == false ? true : false;
        setCopyAgentList([...copyAgentList])
    }
    return (


        <SimpleDialog
            fullWidth
            maxWidth="xs"
            customClass={classes.customClassdialogContent}
            open={isOpenAgentDg}
            title="افزودن نماینده "
            onClose={() => setIsOpenAgentDg(false)}

        >


            <Grid container alignItems="center" >
                <Grid style={{ position: 'relative', width: '100%' }}>
                    <Typography className={classes.font13} component="p">منظور از نماینده، امضاداران مجاز مطابق شرایط برداشت روزنامه رسمی می باشد.</Typography>
                    <Grid style={{ textAlign: 'justify' }}>

                        {
                            copyAgentList.map((item, index) => (
                                <Grid md={12} xs={12}
                                    className={clsx(classes.chkItem, item['isSelected'] && classes.activeItem)}
                                    onClick={() => { onToggleChecked(item) }}>
                                    <div>
                                        <Checkbox
                                            checked={item.isSelected}
                                            value={item.isSelected}
                                            color="primary"
                                            icon={<CheckBoxIcon />}
                                            checkedIcon={<CheckBoxIconFill />}
                                        />
                                        <span style={{ fontWeight: 'bold' }} className={item['isSelected'] && classes.colorActive}>{item?.relatedCustomerFirstName + ' ' + item?.relatedCustomerLastName}</span>
                                    </div>
                                    <div className={item['isSelected'] ? classes.colorActivePlace : classes.colorPlace}>{item?.relationTypeValue}</div>
                                </Grid>
                            ))
                        }


                    </Grid>
                    <Grid md={12} xs={12} lg={12}
                        style={{ display: 'flex', marginTop: '16px', flexDirection: 'row-reverse' }}
                    >

                        <ButtonLoading
                            type="button"
                            variant="contained"
                            color="primary"
                            disabled={copyAgentList.filter(a => a.isSelected == true).length <= 0}
                            name={
                                <>
                                    <span style={{ marginLeft: '10px', display: 'flex' }} >
                                        <Icons icon='plusCircle' color="#fff" size="18" />
                                    </span>
                                    افزودن
                                </>
                            }
                            onClick={() => {
                                setAgentList([...JSON.parse(JSON.stringify(copyAgentList))])
                                setIsOpenAgentDg(false)
                            }}
                        />
                        <ButtonLoading
                            style={{ margin: '0 8px' }}
                            variant="contained"

                            color="default"
                            //loading={loadingBtn}
                            name="انصراف"
                            onClick={() => setIsOpenAgentDg(false)}
                        />



                    </Grid>
                </Grid>
            </Grid>


        </SimpleDialog>
    )
}

export default AddAgentDg;

